import React, { useEffect, useState } from 'react'
import * as yup from 'yup';

// Helper
import { createCssClass } from '../../helpers/common';

// css
import './TextInput.css';

interface Props extends React.HTMLProps<HTMLInputElement> {
  id: string;
  name: string;
  label: string;
  value: string;

  className?: string;
  suggestion?: string;
  type?: 'text' | 'tel' | 'email' | 'password';
  required?: boolean;

  pattern?: string;
  patternErrorMessage?: string;
  yupSchema?: yup.StringSchema<string>;
}

const TextInput: React.FC<Props> = (
  {
    id, value, name, className, label, suggestion, pattern, patternErrorMessage = 'Invalid input', yupSchema, type = 'text', required = false, ...rest }) => {

  const [validationMessage, setValidationMessage] = useState<string>('');

  useEffect(() => {
    if (yupSchema) {
      yupSchema.validate(value, { strict: true })
        .then(() => setValidationMessage(''))
        .catch((err: yup.ValidationError) => { if (validationMessage) setValidationMessage(err.message) }); // Update only if there is a message
    }
  }, [value, yupSchema, validationMessage]);

  const onInvalid = (e: React.FormEvent<HTMLInputElement>) => {
    setValidationMessage(patternErrorMessage);
  };

  const onBlur = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;

    if (pattern) {
      const regex = new RegExp(`${pattern}`);
      const test = regex.test(value);
      if (!test) setValidationMessage(patternErrorMessage);
      else setValidationMessage('');
    }

    else if (yupSchema) {
      yupSchema.validate(value, { strict: true })
        .then(() => setValidationMessage(''))
        .catch((err: Error) => setValidationMessage(err.message));
    }

    else { }
  };

  // const isRequired = () => {
  //   return required ? <span className='required'>*</span> : null;
  // }

  return (

    <div className={createCssClass(['text-input', name])}>

      <div className='label-wrapper'>
        <label className={createCssClass([name])} htmlFor={id}>{label}
          {/* {!required && <span className='optional'> - opzionale</span>} */}
        </label>
        {!!suggestion && <span className='suggestion'>{suggestion}</span>}
      </div>

      <input
        id={id}
        type={type}
        className={createCssClass([name, className, validationMessage ? 'invalid' : ''])}
        value={value}
        onInvalid={onInvalid}
        onBlur={onBlur}
        pattern={pattern}
        {...rest}
      />

      <input type="hidden" name={name} value={value} />

      {!!validationMessage && <div className={createCssClass(['validation-message'])}>{validationMessage}</div>}

    </div>
  );
}
export default TextInput;